import type { Order } from "./types";

const terminalStatuses = new Set(["delivered", "cancelled"]);

export function findIncomingOrders(
  knownOrderIds: ReadonlySet<string>,
  nextOrders: Order[],
): Order[] {
  return nextOrders.filter(
    (order) => !knownOrderIds.has(order.id) && !terminalStatuses.has(order.status),
  );
}

export function orderIdSet(orders: Order[]): Set<string> {
  return new Set(orders.map((order) => order.id));
}
